<template>
    <div class="home-box">
        <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
        <v-card>
            <v-card-title dark>
                <h3 class="ma-2">Project Reports Zone Wise (30th November 2025)</h3>
                <v-spacer></v-spacer>
                <AutocompleteIdSearch @changeData="zoneId = $event" :storeLink="'member/getAllZones'" :setectVale="zoneId"
                :itemText="'name'" :label="'Select Zone'" />
                <v-spacer></v-spacer>
                <v-btn @click="loadTaskList()" :disabled="loading || !zoneId">Download</v-btn>

            </v-card-title>

        </v-card>

    </div>
</template>

<script>
import MonthsList from "@/utility/months.json";
import { ProjectService } from "@/services/project-service";
import { checkError } from "@/config/errors.js";
import AutocompleteIdSearch from "@/components/shared/AutocompleteIdSearch";
import { fileService } from "@/config/file-service.js";

export default {
    name: "ProjectZoneWiseReport",
    components: { AutocompleteIdSearch },

    data: function () {
        return {
            loading: false,
            filterBtnTTip: false,
            month: "",
            months: MonthsList,
            list: [],
            zoneId: null,
            role: localStorage.getItem("role"),
            errors: null,
            successMsg: "",
            snackbar: false,           
        };
    },

    mounted() {
        this.$store.dispatch("auth/getProfile");

        localStorage.removeItem("maf_contribution_uuid");
        localStorage.removeItem("mjf_contribution_uuid");
        localStorage.removeItem("service_project_uuid");
        if (this.role == 'CLUB_PRESIDENT' || this.role == 'CLUB_SECRETARY' || this.role == 'CLUB_TREASURER' || this.role == 'CLUB_ADMINISTRATOR') {
            localStorage.removeItem("activity_club");
            this.zoneId = localStorage.getItem("club_id");
        }
    },

    watch: {
        zoneId(val) {
           this.zoneId = val;
        }
    },

    methods: {
        loadTaskList() {
            if (this.zoneId) {
                this.loading = true;
                ProjectService.getProjectZoneReport(this.zoneId, {
                    responseType: "blob",
                })
                    .then((response) => {
                        this.loading = false;
                        if (response.data) {
                            this.list = response.data;
                            this.loading = false;
                            let fileType = response.headers["content-type"];
                            let extension = "csv";
                            fileService.downloadFile(
                                response.data,
                                fileType,
                                extension,
                                "project-" + this.zoneId
                            );
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        let data = error.response.data;
                        let errorOutput = checkError.errorFormatting(data);
                        this.errors = errorOutput;
                        this.list = [];
                    });
            }

        }


    },
};
</script>
<style>
/* td.rotate {        
height: 400px;
white-space: nowrap;
min-width: 40px;
}

td.rotate-0 {
    min-width: 120px;
}



td.rotate>div {
    transform:
    translate(25px, 51px)       
    rotate(270deg);
    width: 30px;
}

td.rotate>div>span {
    border-bottom: 1px solid #ccc;
    padding: 5px 5px;
    font-size: 11px;
    max-height: 100px;
}

*/
</style>